 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"acquisition-tools~auth~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-pu~edf85516":"acquisition-tools~auth~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-pu~edf85516","acquisition-tools~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-purchas~743fb5b3":"acquisition-tools~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-purchas~743fb5b3","acquisition-tools~cart~dialog-shopee~finance~home~packaging~product~refid~setting~stocks-inventory~t~3074a010":"acquisition-tools~cart~dialog-shopee~finance~home~packaging~product~refid~setting~stocks-inventory~t~3074a010","acquisition-tools":"acquisition-tools","biolink~finance~invoice-view-purchase~packaging~product~stocks-inventory~transaction~user":"biolink~finance~invoice-view-purchase~packaging~product~stocks-inventory~transaction~user","finance":"finance","packaging":"packaging","product":"product","stocks-inventory":"stocks-inventory","transaction":"transaction","user":"user","cart":"cart","dialog-shopee":"dialog-shopee","home":"home","refid":"refid","setting":"setting","biolink":"biolink","invoice-view-purchase":"invoice-view-purchase","discount":"discount","invoice-view":"invoice-view","knowledge-base":"knowledge-base","product-search":"product-search","reward":"reward","search-customer":"search-customer","auth":"auth","popup":"popup","v-currency":"v-currency","ebright-editor":"ebright-editor","map":"map","module-learning":"module-learning","pdf-viewer":"pdf-viewer"}[chunkId]||chunkId) + "." + {"acquisition-tools~auth~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-pu~edf85516":"be99d043","acquisition-tools~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-purchas~743fb5b3":"37651ecf","acquisition-tools~cart~dialog-shopee~finance~home~packaging~product~refid~setting~stocks-inventory~t~3074a010":"6525c6ff","acquisition-tools":"6edb5e31","biolink~finance~invoice-view-purchase~packaging~product~stocks-inventory~transaction~user":"f96adf51","finance":"778a3238","packaging":"725eebea","product":"8f430ae7","stocks-inventory":"8486f113","transaction":"5a09e00c","user":"663a6dc8","cart":"892fc00a","dialog-shopee":"a359fa7a","home":"ab1e162a","refid":"a6d6f1d2","setting":"8902b395","biolink":"d326c541","invoice-view-purchase":"311db2b8","discount":"535cc745","invoice-view":"c1464724","knowledge-base":"1a9f5d0f","product-search":"7c8ab6ea","reward":"1020bd65","search-customer":"ef48875a","auth":"ffb7c15a","popup":"c9b3fc9e","v-currency":"b2bbfda9","ebright-editor":"3563202c","map":"6e85d98e","module-learning":"41fa6ae9","pdf-viewer":"3057e469"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"acquisition-tools~auth~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-pu~edf85516":1,"acquisition-tools~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-purchas~743fb5b3":1,"acquisition-tools~cart~dialog-shopee~finance~home~packaging~product~refid~setting~stocks-inventory~t~3074a010":1,"acquisition-tools":1,"biolink~finance~invoice-view-purchase~packaging~product~stocks-inventory~transaction~user":1,"packaging":1,"product":1,"stocks-inventory":1,"transaction":1,"user":1,"cart":1,"dialog-shopee":1,"home":1,"refid":1,"setting":1,"biolink":1,"invoice-view-purchase":1,"discount":1,"invoice-view":1,"knowledge-base":1,"product-search":1,"reward":1,"search-customer":1,"auth":1,"popup":1,"ebright-editor":1,"map":1,"module-learning":1,"pdf-viewer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"acquisition-tools~auth~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-pu~edf85516":"acquisition-tools~auth~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-pu~edf85516","acquisition-tools~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-purchas~743fb5b3":"acquisition-tools~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-purchas~743fb5b3","acquisition-tools~cart~dialog-shopee~finance~home~packaging~product~refid~setting~stocks-inventory~t~3074a010":"acquisition-tools~cart~dialog-shopee~finance~home~packaging~product~refid~setting~stocks-inventory~t~3074a010","acquisition-tools":"acquisition-tools","biolink~finance~invoice-view-purchase~packaging~product~stocks-inventory~transaction~user":"biolink~finance~invoice-view-purchase~packaging~product~stocks-inventory~transaction~user","finance":"finance","packaging":"packaging","product":"product","stocks-inventory":"stocks-inventory","transaction":"transaction","user":"user","cart":"cart","dialog-shopee":"dialog-shopee","home":"home","refid":"refid","setting":"setting","biolink":"biolink","invoice-view-purchase":"invoice-view-purchase","discount":"discount","invoice-view":"invoice-view","knowledge-base":"knowledge-base","product-search":"product-search","reward":"reward","search-customer":"search-customer","auth":"auth","popup":"popup","v-currency":"v-currency","ebright-editor":"ebright-editor","map":"map","module-learning":"module-learning","pdf-viewer":"pdf-viewer"}[chunkId]||chunkId) + "." + {"acquisition-tools~auth~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-pu~edf85516":"f2728a98","acquisition-tools~biolink~cart~dialog-shopee~discount~finance~home~invoice-view~invoice-view-purchas~743fb5b3":"31d08bf0","acquisition-tools~cart~dialog-shopee~finance~home~packaging~product~refid~setting~stocks-inventory~t~3074a010":"e5aeba1d","acquisition-tools":"71de997d","biolink~finance~invoice-view-purchase~packaging~product~stocks-inventory~transaction~user":"1816d381","finance":"31d6cfe0","packaging":"1fb04e29","product":"266b0209","stocks-inventory":"f92a4495","transaction":"cbd8ef55","user":"b083abd0","cart":"7a0cda0b","dialog-shopee":"cc7f943d","home":"917cbf3a","refid":"c6ec1892","setting":"2e8ea13a","biolink":"0570d947","invoice-view-purchase":"f0222215","discount":"87440e01","invoice-view":"ab58ad0e","knowledge-base":"7cebbfcb","product-search":"297d45b6","reward":"12d1df81","search-customer":"297d45b6","auth":"da4e1bd1","popup":"71de997d","v-currency":"31d6cfe0","ebright-editor":"16ecc387","map":"f92df0d2","module-learning":"3e78ea34","pdf-viewer":"cd3362da"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
